type ViewWrapperProps = {
  children: React.ReactNode;
};

export default function ViewWrapper({ children }: ViewWrapperProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4">
      <div className="w-full max-w-md">{children}</div>
    </div>
  );
}
